export const hints = [
  {
    id: 'panel-switch-2026-07',
    title: 'Alterne entre escola e vendedor',
    body: 'Use este botão para trocar rapidamente entre o painel da escola e o painel do vendedor.',
    expiresAt: '2026-08-24',
  },
  {
    id: 'nav-collapse-2026-08',
    title: 'Recolha o menu lateral',
    body: 'Use este botão para recolher o menu e ganhar mais espaço na tela.',
    expiresAt: '2026-09-05',
  },
  {
    id: 'partnership-setup-2026-10',
    title: 'Abrir uma parceria ficou mais simples',
    body: 'Agora, em Nova parceria, você é guiado passo a passo: do CNPJ da instituição até a loja pronta para vender.',
    actionLabel: 'Conhecer o novo fluxo',
    expiresAt: '2026-10-31',
  },
];
